import NHSVHomePage from '../components/homepage';
import NHSVAccountDetailPage from '../components/nhsv/account-detail';
import NHSVAppRightsPage from '../components/nhsv/app-rights';
import NHSVLinkAccountPage from '../components/nhsv/link-account';
import NHSVLookupAccountPage from '../components/nhsv/lookup-account';
import NHSVOrderHistoryPage from '../components/nhsv/order-history';
import NHSVRightsHistoryPage from '../components/nhsv/rights-history';
import NHSVSecuritiesPricePage from '../components/nhsv/securities-price';
import {
  NHSVWebhookCreatePage,
  NHSVWebhookDetailPage,
  NHSVWebhookEditPage,
  NHSVWebhookListPage,
} from '../components/nhsv-webhooks/pages';

const nhsvRoutes = [
  { path: '/nhsv/home', element: <NHSVHomePage /> },
  { path: '/nhsv/lookup-account', element: <NHSVLookupAccountPage /> },
  { path: '/nhsv/link-account', element: <NHSVLinkAccountPage /> },
  { path: '/nhsv/account-detail', element: <NHSVAccountDetailPage /> },
  { path: '/nhsv/order-history', element: <NHSVOrderHistoryPage /> },
  { path: '/nhsv/rights-history', element: <NHSVRightsHistoryPage /> },
  { path: '/nhsv/app-rights', element: <NHSVAppRightsPage /> },
  { path: '/nhsv/securities-price', element: <NHSVSecuritiesPricePage /> },
  { path: '/nhsv/webhook-configs', element: <NHSVWebhookListPage /> },
  { path: '/nhsv/webhook-configs/create', element: <NHSVWebhookCreatePage /> },
  { path: '/nhsv/webhook-configs/:id', element: <NHSVWebhookDetailPage /> },
  { path: '/nhsv/webhook-configs/:id/edit', element: <NHSVWebhookEditPage /> },
];

export default nhsvRoutes;
